import Table from "../../components/Table";
import Layout from "../../components/Layout";

export default function ApiKeysPage() {
  return (
    <Layout metaTitle="Organization API Keys">
      <Table
        url="/d/apikeys/org_apikey/"
        formURL="/d/apikeys/org_apikey/form/"
        tableName="Organization API Key"
        tableDescription="Organization keys are mainly to authenticate organization level requests such as Account APIs."
      />
    </Layout>
  );
}

ApiKeysPage.parentPath = "/api-keys";
